import React from "react";
import { useJsApiLoader } from "@react-google-maps/api";

const libraries = ["places", "geometry"];

export default function GoogleMapsProvider({ children }) {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyC4pMTUAOY3mwpkK-PJVWyynlPa5cBRRjA",
    libraries,
  });

  if (!isLoaded) return <div>Loading Google Maps...</div>;

  return <>{children}</>;
}
